import config from 'configs';

const viewSwitcher = (ClassicView, AsianView, props = {}) => {
  const Component = config.currentSkin === 'asian' ? AsianView : ClassicView;

  return <Component {...props} />;
};

export default viewSwitcher;
